import axios from 'axios'

import { log, token, connection } from './interceptors'

import { config } from '../../../constants'

const instance = axios.create({
  baseURL: config.baseURL,
  headers: {},
  data: {},
  timeout: 180000
})
const httpCustomInstance = axios.create({
  baseURL: process.env.REACT_APP_MODAL_ORG_API,
  headers: {},
  data: {},
  timeout: 180000
})

const httpCustomAudioInstance = axios.create({
  baseURL: process.env.REACT_APP_AUDIO_API,
  headers: {},
  data: {}
})

const httpCustomSummarizedInstance = axios.create({
  baseURL: process.env.REACT_APP_SUMMARIZATION,
  headers: {},
  data: {}
})

const httpShareBotInstance = axios.create({
  baseURL: process.env.REACT_APP_SHAREBOT_API,
  headers: {},
  data: {}
})

const questionAnswerAiInstance = axios.create({
  baseURL: config.questionAnswerAiUrl,
  headers: {},
  data: {}
})

const readableAiInstance = axios.create({
  baseURL: config.readableAiUrl,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    Accept: 'text/event-stream'
  },
  data: {}
})

const aiCourseCreationInstance = axios.create({
  baseURL: process.env.REACT_APP_AI_COURSE_CREATION_URL,
  headers: {},
  data: {}
})
const imageCreationInstance = axios.create({
  headers: {
    'Content-Type': 'application/json'
  },
  data: {},
  timeout: 300000
})
const podcastGeneratioonInstance = axios.create({
  headers: {
    'Content-Type': 'application/json',
    Accept: 'text/event-stream'
  },
  data: {},
  timeout: 300000
})

const videoAiInstance = axios.create({
  baseURL: config.videoAiUrl,
  headers: {},
  data: {}
})

const videoGenerationInstance = axios.create({
  baseURL: config.videoGenerationUrl,
  headers: {},
  data: {}
})

token(instance)
log(instance)
connection(instance)

token(httpCustomInstance)
log(httpCustomInstance)
connection(httpCustomInstance)

token(httpCustomAudioInstance)
log(httpCustomAudioInstance)
connection(httpCustomAudioInstance)

token(httpCustomSummarizedInstance)
log(httpCustomSummarizedInstance)
connection(httpCustomSummarizedInstance)

token(httpShareBotInstance)
log(httpShareBotInstance)
connection(httpShareBotInstance)

token(questionAnswerAiInstance)
log(questionAnswerAiInstance)
connection(questionAnswerAiInstance)

token(aiCourseCreationInstance)
log(aiCourseCreationInstance)
connection(aiCourseCreationInstance)

token(videoAiInstance)
log(videoAiInstance)
connection(videoAiInstance)

token(imageCreationInstance)
log(imageCreationInstance)
connection(imageCreationInstance)

export {
  podcastGeneratioonInstance,
  httpCustomInstance,
  httpCustomAudioInstance,
  httpCustomSummarizedInstance,
  httpShareBotInstance,
  questionAnswerAiInstance,
  aiCourseCreationInstance,
  videoAiInstance,
  videoGenerationInstance,
  imageCreationInstance,
  readableAiInstance
}

export default instance
